import { Col, Form, Input, message, Row } from "antd";
import React, { useState } from "react";
import s from "./Register.module.scss";
import { Link, useNavigate } from "react-router-dom";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { useForm } from "antd/es/form/Form";
import { register } from "../../redux/carSlice";

const Register = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const dispatch = useDispatch();
  const [form] = useForm();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const error = () => {
    messageApi.open({
      type: "error",
      content: "Пользователь с такой почтой уже зарегестрирован",
    });
  };

  const registerUser = async (values) => {
    try {
      const res = await dispatch(
        register({
          email: values.email,
          password: values.password,
        })
      );

      if (res.payload === "Request failed with status code 400") {
        error();
      } else {
        navigate("/activateAccount");
      }
      console.log("res", res);
    } catch (err) {
      console.log("err", err);
    }
  };

  return (
    <div className={s.login}>
      {contextHolder}
      <h2 className={s.h2}>
        <img src='/cncars_logo.png' className={s.logo} /> Зарегистрироваться
      </h2>
      <Form
        className={s.form}
        layout='vertical'
        form={form}
        onFinish={registerUser}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              name='email'
              label='Email'
              rules={[
                { required: true, message: "Введите email" },
                { type: "email", message: "Укажите корректный email" },
              ]}
            >
              <input placeholder='Введите вашу почту' className={s.input} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name='password'
              label='Пароль'
              rules={[
                { required: true, message: "Введите пароль" },
                {
                  min: 4,
                  message: "Пароль должен состоять не менее, чем из 4 цифр",
                },
                // {
                //   pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/,
                //   message:

                //     "Password must include at least one uppercase letter, one lowercase letter, and one number!",
                // },
              ]}
            >
              <Input.Password
                type={showPassword ? "text" : "password"}
                iconRender={(visible) =>
                  visible ? (
                    <EyeOutlined className={s.icon} />
                  ) : (
                    <EyeInvisibleOutlined />
                  )
                }
                suffix={
                  showPassword ? (
                    <EyeOutlined
                      onClick={togglePasswordVisibility}
                      style={{ color: "rgb(248, 116, 64)" }}
                    />
                  ) : (
                    <EyeInvisibleOutlined onClick={togglePasswordVisibility} />
                  )
                }
                placeholder='Введите ваш пароль'
                className={s.password_input}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name='confirmPassword'
              label='Потвердитe пароль'
              dependencies={["password"]}
              rules={[
                { required: true, message: "Введите пароль еще раз" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Пароли не совпадают!"));
                  },
                }),
              ]}
            >
              <Input.Password
                type={showPassword ? "text" : "password"}
                iconRender={(visible) =>
                  visible ? (
                    <EyeOutlined style={{ color: "rgb(248, 116, 64)" }} />
                  ) : (
                    <EyeInvisibleOutlined />
                  )
                }
                suffix={
                  showPassword ? (
                    <EyeOutlined
                      onClick={toggleConfirmPasswordVisibility}
                      className={s.icon}
                    />
                  ) : (
                    <EyeInvisibleOutlined
                      onClick={toggleConfirmPasswordVisibility}
                    />
                  )
                }
                placeholder='Введите ваш пароль еще раз'
                className={s.password_input}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <button className={s.enter_btn} type='htmlSubmit'>
            Зарегистрироваться{" "}
          </button>
        </Row>
        <div className={s.no_account}>
          Уже есть аккаунт? &nbsp;
          <Link to='/login' className={s.register_btn}>
            Войти
          </Link>
        </div>
      </Form>
    </div>
  );
};

export default Register;
